import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Pagination from "@material-ui/lab/Pagination";
import { SelectBox } from "devextreme-react/select-box";
import arrowsIcon from "../../images/arrow-up-down-icon.svg";
import { Template } from "devextreme-react";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 15,
    marginBottom: 20,
  },
  icon: {
    color: "#397CB7",
  },
}));

function renderDropdownIcon() {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        width: "100%",
      }}
    >
      <img style={{ height: "2rem", width: "1.25rem" }} src={arrowsIcon} />
    </div>
  );
}

export default function CustomPagination(props) {
  const { t } = useTranslation();
  const { totalPages, loading, pageSize, pageIndex, count } = props;
  const classes = useStyles();
  const dataSource = props.numElements ? props.numElements : [15, 50, 100];

  const firstItem = (pageIndex - 1) * pageSize + 1;
  const lastItem = Math.min(pageIndex * pageSize, count);

  return (
    <div className={classes.root}>
      <div style={{display: "flex", alignItems: "center", gap: "1rem"}}>
        {props.showNumPerPage == null || props.showNumPerPage == undefined || props.showNumPerPage == true && 
          <span>
            <SelectBox
              labelMode={"static"}
              label={t("Table.Pagination.NumPerPage")}
              disabled={loading !== "succeeded"}
              dataSource={dataSource}
              value={pageSize}
              onValueChange={props.handlePageSizeChange}
              showDropDownButton
              dropDownButtonTemplate="dropdownIcon"
            >
              <Template name="dropdownIcon" render={renderDropdownIcon} />
            </SelectBox>
          </span>
        }
        <span>
          {t("Table.Pagination.ItemsCount", {
            firstItem: firstItem,
            lastItem: lastItem,
            count: count,
          })}
        </span>
      </div>
      <Pagination
        page={pageIndex}
        disabled={loading !== "succeeded"}
        count={totalPages}
        color="primary"
        onChange={props.handlePageIndexChange}
      />
    </div>
  );
}
